var _defs, _circle, _path, _path2, _path3, _path4, _path5, _path6, _ellipse, _ellipse2, _ellipse3, _path7, _path8, _path9, _rect, _rect2, _circle2, _path10, _polygon, _path11, _path12, _ellipse4, _circle3, _polygon2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _circle4, _path13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgServerDown(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1119.60911 699",
    height: 699,
    width: 1119.60911,
    id: "aa03ddf9-f8f2-4819-a4ce-be9b0a220741",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs107"
  })), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title2"
  }, "server down") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title2"
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "circle4",
    fill: "#f2f2f2",
    r: 213,
    cy: 213,
    cx: 292.60911
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path6",
    fill: "#2f2e41",
    transform: "translate(-31.39089 -100.5)",
    d: "M31.39089,151.64237c0,77.49789,48.6181,140.20819,108.70073,140.20819"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path8",
    fill: "#e86e45",
    transform: "translate(-31.39089 -100.5)",
    d: "M140.09162,291.85056c0-78.36865,54.255-141.78356,121.30372-141.78356"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "path10",
    fill: "#e86e45",
    transform: "translate(-31.39089 -100.5)",
    d: "M70.77521,158.66768c0,73.61476,31.00285,133.18288,69.31641,133.18288"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "path12",
    fill: "#2f2e41",
    transform: "translate(-31.39089 -100.5)",
    d: "M140.09162,291.85056c0-100.13772,62.7103-181.16788,140.20819-181.16788"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "path14",
    fill: "#a8a8a8",
    transform: "translate(-31.39089 -100.5)",
    d: "M117.22379,292.83905s15.41555-.47479,20.06141-3.783,23.713-7.2585,24.86553-1.95278,23.16671,26.38821,5.76263,26.5286-40.43935-2.711-45.07627-5.53549S117.22379,292.83905,117.22379,292.83905Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "path16",
    opacity: 0.2,
    transform: "translate(-31.39089 -100.5)",
    d: "M168.224,311.78489c-17.40408.14042-40.43933-2.71094-45.07626-5.53548-3.53126-2.151-4.93843-9.86945-5.40926-13.43043-.32607.014-.51463.02-.51463.02s.97638,12.43276,5.61331,15.2573,27.67217,5.67589,45.07626,5.53547c5.02386-.04052,6.7592-1.82793,6.66391-4.47526C173.87935,310.756,171.96329,311.75474,168.224,311.78489Z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "ellipse18",
    fill: "#3f3d56",
    ry: 25.43993,
    rx: 187,
    cy: 424.5,
    cx: 198.60911
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    id: "ellipse20",
    opacity: 0.1,
    ry: 21.35866,
    rx: 157,
    cy: 424.5,
    cx: 198.60911
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    id: "ellipse22",
    fill: "#3f3d56",
    ry: 38.5,
    rx: 283,
    cy: 660.5,
    cx: 836.60911
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2f2e41",
      strokeWidth: 1.69090354,
      strokeMiterlimit: 10
    },
    id: "path26",
    strokeMiterlimit: 10,
    d: "m 430.59516,510.96625 c 93.95408,16.62072 290.72043,19.39898 311.72305,58.19697"
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "path28",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    stroke: "#2f2e41",
    fill: "none",
    transform: "translate(-31.39089 -100.5)",
    d: "M341,359.5s130-36,138,80-107,149-17,172"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "path32",
    fill: "#2f2e41",
    transform: "translate(-31.39089 -100.5)",
    d: "M810.09554,663.73988,802.218,714.03505s-38.78182,20.60284-11.51335,21.20881,155.73324,0,155.73324,0,24.84461,0-14.54318-21.81478l-7.87756-52.719Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "path34",
    opacity: 0.1,
    transform: "translate(-31.39089 -100.5)",
    d: "M785.21906,734.69812c6.193-5.51039,16.9989-11.252,16.9989-11.252l7.87756-50.2952,113.9216.10717,7.87756,49.582c9.185,5.08711,14.8749,8.987,18.20362,11.97818,5.05882-1.15422,10.58716-5.44353-18.20362-21.38921l-7.87756-52.719-113.9216,3.02983L802.218,714.03506S769.62985,731.34968,785.21906,734.69812Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "rect36",
    fill: "#2f2e41",
    rx: 18.04568,
    height: 357.51989,
    width: 513.25314,
    y: 212.68859,
    x: 578.43291
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "rect38",
    fill: "#3f3d56",
    height: 267.83694,
    width: 478.71308,
    y: 231.77652,
    x: 595.70294
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "circle40",
    fill: "#f2f2f2",
    r: 3.02983,
    cy: 223.29299,
    cx: 835.05948
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "path42",
    fill: "#2f2e41",
    transform: "translate(-31.39089 -100.5)",
    d: "M1123.07694,621.32226V652.6628a18.04341,18.04341,0,0,1-18.04568,18.04568H627.86949A18.04341,18.04341,0,0,1,609.8238,652.6628V621.32226Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    id: "polygon44",
    fill: "#2f2e41",
    points: "968.978 667.466 968.978 673.526 642.968 673.526 642.968 668.678 643.417 667.466 651.452 645.651 962.312 645.651 968.978 667.466"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "path46",
    fill: "#2f2e41",
    transform: "translate(-31.39089 -100.5)",
    d: "M1125.828,762.03359c-.59383,2.539-2.83591,5.21743-7.90178,7.75032-18.179,9.08949-55.1429-2.42386-55.1429-2.42386s-28.4804-4.84773-28.4804-17.573a22.72457,22.72457,0,0,1,2.49658-1.48459c7.64294-4.04351,32.98449-14.02122,77.9177.42248a18.73921,18.73921,0,0,1,8.54106,5.59715C1125.07908,756.45353,1126.50669,759.15715,1125.828,762.03359Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "path48",
    opacity: 0.1,
    transform: "translate(-31.39089 -100.5)",
    d: "M1125.828,762.03359c-22.251,8.526-42.0843,9.1622-62.43871-4.975-10.26507-7.12617-19.59089-8.88955-26.58979-8.75618,7.64294-4.04351,32.98449-14.02122,77.9177.42248a18.73921,18.73921,0,0,1,8.54106,5.59715C1125.07908,756.45353,1126.50669,759.15715,1125.828,762.03359Z"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    id: "ellipse50",
    fill: "#f2f2f2",
    ry: 2.42386,
    rx: 7.87756,
    cy: 654.13477,
    cx: 1066.53846
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "circle52",
    fill: "#f2f2f2",
    r: 11.51335,
    cy: 545.66686,
    cx: 835.05948
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    id: "polygon54",
    opacity: 0.1,
    points: "968.978 667.466 968.978 673.526 642.968 673.526 642.968 668.678 643.417 667.466 968.978 667.466"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "rect56",
    fill: "#2f2e41",
    height: 242,
    width: 208,
    y: 159,
    x: 108.60911
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "rect58",
    fill: "#3f3d56",
    height: 86,
    width: 250,
    y: 135,
    x: 87.60911
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "rect60",
    fill: "#3f3d56",
    height: 86,
    width: 250,
    y: 237,
    x: 87.60911
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "rect62",
    fill: "#3f3d56",
    height: 86,
    width: 250,
    y: 339,
    x: 87.60911
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "rect64",
    opacity: 0.4,
    fill: "#e86e45",
    height: 16,
    width: 16,
    y: 150,
    x: 271.60911
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "rect66",
    opacity: 0.8,
    fill: "#e86e45",
    height: 16,
    width: 16,
    y: 150,
    x: 294.60911
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    id: "rect68",
    fill: "#e86e45",
    height: 16,
    width: 16,
    y: 150,
    x: 317.60911
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    id: "rect70",
    opacity: 0.4,
    fill: "#e86e45",
    height: 16,
    width: 16,
    y: 251,
    x: 271.60911
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    id: "rect72",
    opacity: 0.8,
    fill: "#e86e45",
    height: 16,
    width: 16,
    y: 251,
    x: 294.60911
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    id: "rect74",
    fill: "#e86e45",
    height: 16,
    width: 16,
    y: 251,
    x: 317.60911
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    id: "rect76",
    opacity: 0.4,
    fill: "#e86e45",
    height: 16,
    width: 16,
    y: 352,
    x: 271.60911
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    id: "rect78",
    opacity: 0.8,
    fill: "#e86e45",
    height: 16,
    width: 16,
    y: 352,
    x: 294.60911
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    id: "rect80",
    fill: "#e86e45",
    height: 16,
    width: 16,
    y: 352,
    x: 317.60911
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "circle92",
    fill: "#fff",
    r: 27,
    cy: 518,
    cx: 318.60911
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "path102",
    fill: "#fff",
    transform: "translate(-31.39089 -100.5)",
    d: "M394,661.5c0,7.732-19.90861,23-42,23s-43-14.268-43-22,20.90861-6,43-6S394,653.768,394,661.5Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServerDown);
export default __webpack_public_path__ + "static/media/server_down.abf775ae2ee74eb3c95eb726be9d7a05.svg";
export { ForwardRef as ReactComponent };